import { useMemo } from 'react';

import useUserData from 'approot/shared/user/user-data';
import { InquisitiveActivitiesContentStatus } from 'global/graphql/scalars.type';
import { canAccessEditActivities } from './activities-permissions';
import { ACTIVITIES_CONTENT_STATUS_DRAFT } from 'global/constants';

export const useCanAccessEdit = (
  status: InquisitiveActivitiesContentStatus | undefined
) => {
  const { canEditActivities, canBuildActivities } = useUserData();

  const canEdit = useMemo(() => {
    return canAccessEditActivities({
      canEditActivities,
      canBuildActivities,
      status: status || ACTIVITIES_CONTENT_STATUS_DRAFT,
    });
  }, [canEditActivities, canBuildActivities, status]);

  return canEdit;
};
